<template>
  <div class="passFang">
    <div>{{ info }}</div>
    <div class="margin-top20">
      <el-upload class="avatar-uploader" action="" :show-file-list="false" multiple
                 :before-upload="beforeAvatarUpload" accept=".jpg,.jpeg,.png" :auto-upload="true"
                 :http-request="uploadFile">
        <img :src="signature" v-if="!this.$method.isEmpty(signature)"
             class="width100Per height100Per objScaleDown"/>
        <div class="column-me center-all" v-else>
          <img class="img24 margin-bottom10" src="../../assets/img/add1.png"/>
          <div style="color: #A6AAB8;">上传签字</div>
        </div>
      </el-upload>
    </div>
    <div class="margin-top20">
      <el-input placeholder="请输入备注信息" type="textarea" style="width: 100%;" clearable
                :class="{'red-border':showRedBorder&&(content===''||content===null)}" v-model="content"
                maxlength="500">
      </el-input>
    </div>
    <div class="row-me row-center flex-end1 margin-top30">
      <div class="btn-blank width140 btn-height40" @click="clickCancel">取消</div>
      <div class="btn-blue width140 btn-height40 margin-left20" @click="clickSave">保存</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    ids: {
      type: Array,
      default: () => [],
    },
    drugs: {
      type: Array,
      default: () => [],
    },
    info: {
      type: String,
      default: '',
    },
    doctorSignature: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      content: '',
      showRedBorder: false,
      signature: this.doctorSignature,
    }
  },
  // html加载完成之前
  created() {

  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //上传图片验证
    beforeAvatarUpload(file) {
      let types = ['image/jpeg', 'image/jpg', 'image/png'];
      const isImage = types.includes(file.type);
      if (!isImage) {
        this.$message.error('上传图片只支持JPG、JPEG、PNG格式!')
        return false
      }
      return true
    },
    //上传
    uploadFile(param) {
      let file = param.file;
      let formData = new FormData();
      formData.append("file", file);
      this.$uploadFileRequest('/file/upload', formData).then((res) => {
        if (res) {
          this.signature = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    clickSave() {
      if (this.$method.isEmpty(this.signature)) {
        this.$message.error("请上传开方医师签字")
        return
      }
      if (this.$method.isEmpty(this.content)) {
        this.showRedBorder = true
        return
      }
      this.$postRequest('/admin/order/check', {
        ids: this.ids,
        pass: true,
        forceReason: this.content,
        drugs: this.drugs,
        doctorSignature: this.signature,
      }).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.bus.$emit('passFangSuccess', 'refresh')
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    clickCancel() {
      this.bus.$emit('passFangSuccess')
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.passFang {
  &:deep(.el-textarea__inner) {
    height: 80px;
  }

  :deep(.avatar-uploader .el-upload) {
    width: 120px;
    height: 120px;
  }
}
</style>
